
import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";
import {
  ApplicationActions,
  ApplicationViewModel, factory, IdentityValueViewModel, PracticeListActions, PracticeRequirementCandidateModel, PracticesClient,
  PracticesRequirementViewModel, PracticeType,
  RequirementFulfillmentViewModel,
  RequirementsClient,
  ValidityStatus,
  PracticePeriod,
  SeafaringProperties,
  ISeafaringProperties,
  PilotageType
} from "@/api-client";
import {BvTableFieldArray} from "bootstrap-vue"
import RequirementsTable from "@/features/applications/components/RequirementsTable.vue";
import TableItem from "@/features/applications/components/TableItem";
import Loader from "@/features/shared/components/Loader";
import {formatDate} from "@/formatting/dateFormatter";
import PopoverInfo from '@/components/PopoverInfo.vue';
import {PopoverProps} from "@/features/applications/components/PopoverProps";
import {ls} from "@/CultureService";
import ValidityStatusBadge from "@/features/shared/components/ValidityStatusBadge.vue";
import AddPracticeModal from "@/features/documents/practices/components/AddPracticeModal.vue";
import translatePracticeKind from "@/features/shared/PracticeKindTranslator";
import Badge from "@/features/shared/components/Badge.vue";

class PracticeTableItem implements TableItem {
id: string;
organizationName: null | string | undefined;
type: string;
kind: string;
positionName: string;
issuedOn: Date;
startedOn: Date;
endedOn: Date;
maxSuitablePeriodDays: number;
status: ValidityStatus;
_details: SeafaringProperties | null | undefined;
seafaringDetails?: SeafaringProperties | null | undefined;
practicePeriods!: PracticePeriod[];
pilotageType?: PilotageType | null;
isDeleted: boolean;

constructor(practice: PracticeRequirementCandidateModel) {
  this.id = practice.id;
  this.organizationName = practice.organizationName;
  this.type = practice.type;
  this.kind = practice.kind;
  this.positionName = practice.positionName ?? '';
  this.issuedOn = practice.issuedOn;
  this.startedOn = practice.startedOn;
  this.endedOn = practice.endedOn;
  this.maxSuitablePeriodDays = practice.maxSuitablePeriodDays;
  this.status = practice.status;
  this.practicePeriods = practice.practicePeriods;
  this.seafaringDetails = practice.seafaringDetails;
  this._details = practice.seafaringDetails;
  this.isDeleted = practice.isDeleted;
  this.pilotageType = practice.pilotageType;
}
}

@Component({
components: {
  RequirementsTable,
  PopoverInfo,
  ValidityStatusBadge,
  AddPracticeModal,
  Badge
}
})
export default class PracticesRequirement extends Vue {
public static requirementDescriptionTitle = ls.Applications_Requirements_Practices_Title_PracticeRequirements;
public static headingDescription = ls.Applications_Requirements_Practices_Heading_AddingPractices;


@Prop({required: true})
application!: ApplicationViewModel; // TODO: Constrain this.
@Prop({required: true})
requirementFulfillment!: RequirementFulfillmentViewModel;
@Prop({required: true})
requirement!: PracticesRequirementViewModel;
@Prop({required: true})
requirementValue!: IdentityValueViewModel | null;
@Prop({required: true})
actions!: ApplicationActions;

customHeader?: string | null;
practiceListActions: PracticeListActions = factory.create(PracticeListActions);

chosenPractices: PracticeRequirementCandidateModel[] = [];
choosablePractices: PracticeRequirementCandidateModel[] = [];

suitableEducationalPeriodDays = 0;
suitableWorkPeriodDays = 0;
totalSuitablePracticeDays = 0;

totalSuitableEducationalNavigationalWatchDays = 0;
totalSuitableEducationalEngineWatchDays = 0;
totalSuitableWorkNavigationalWatchDays = 0;
totalSuitableWorkEngineWatchDays = 0;

educationalPeriodPracticeDays = 0;
workPracticePeriodDays = 0;
totalPracticePeriodDays = 0;

totalEducationalNavigationalWatchDays = 0;
totalEducationalEngineWatchDays= 0;
totalWorkNavigationalWatchDays= 0;
totalWorkEngineWatchDays= 0;

educationalPeriodPracticeCount = 0;
workPracticePeriodCount = 0;
totalPracticePeriodCount = 0;

suitableEducationalPeriodCount = 0;
suitableWorkPeriodCount = 0;
totalSuitablePracticeCount = 0;

chosenLoader = new Loader();
choosableLoader = new Loader();

popoverProps: PopoverProps = new PopoverProps('maxSuitablePeriodDays', this.$ls.Applications_Requirements_Practices_Popover_AboutPracticeDaysCountingInTable);
titleUpdated = false;
$refs!:{
    addPracticeModal: AddPracticeModal;
}

async created() {
    this.practiceListActions = await new PracticesClient().availableListActions(this.application.seafarerId);

  if (this.requirementValue) {
    await new RequirementsClient()
        .setLoader(this.chosenLoader)
        .chosenPractices(this.application.id, this.requirement.id)
        .then(result =>
          {
            this.chosenPractices = result.practices;
            this.suitableEducationalPeriodDays = result.suitableEducationalPracticePeriodDays;
            this.suitableWorkPeriodDays = result.suitableWorkPracticePeriodDays;

            this.totalSuitablePracticeDays = result.totalSuitablePracticePeriodDays;
            this.totalSuitableEducationalNavigationalWatchDays = result.totalSuitableEducationalNavigationalWatchDays;
            this.totalSuitableEducationalEngineWatchDays = result.totalSuitableEducationalEngineWatchDays;
            this.totalSuitableWorkNavigationalWatchDays = result.totalSuitableWorkNavigationalWatchDays;
            this.totalSuitableWorkEngineWatchDays = result.totalSuitableWorkEngineWatchDays;

            this.educationalPeriodPracticeDays = result.educationalPracticePeriodDays;
            this.workPracticePeriodDays = result.workPracticePeriodDays;
            this.totalPracticePeriodDays = result.totalPracticePeriodDays;

            this.totalEducationalNavigationalWatchDays = result.totalEducationalNavigationalWatchDays;
            this.totalEducationalEngineWatchDays = result.totalEducationalEngineWatchDays;
            this.totalWorkNavigationalWatchDays = result.totalWorkNavigationalWatchDays;
            this.totalWorkEngineWatchDays = result.totalWorkEngineWatchDays;

            this.educationalPeriodPracticeCount = result.educationalPracticePeriodCount || 0;
            this.workPracticePeriodCount = result.workPracticePeriodCount || 0;
            this.totalPracticePeriodCount = result.totalPracticePeriodCount || 0;

            this.suitableEducationalPeriodCount = result.suitableEducationalPracticePeriodCount || 0;
            this.suitableWorkPeriodCount = result.suitableWorkPracticePeriodCount || 0;
            this.totalSuitablePracticeCount = result.totalSuitablePracticePeriodCount || 0;

            if (result.error.hasMessages()) {
              this.$emit("error-happened", result.error);
            }
          });
  }

  if (this.actions.canFillRequirements) {
    await new RequirementsClient()
        .setLoader(this.choosableLoader)
        .choosable(this.application.id, this.requirement.id)
        .then(result =>{
          this.choosablePractices = result
      });
  }

  // Always use requirement.practiceType as the source of truth for the heading
  this.customHeader = this.getPracticeTypeName(this.requirement.practiceType);
  if(this.customHeader){
    this.$emit("title-changed",this.customHeader)
  }
}

getPracticeTypeName(practiceType: PracticeType): string {
  switch (practiceType) {
    case PracticeType.Seafaring:
      return ls.Global_PracticeType_SeafaringPractice;
    case PracticeType.Pilotage:
      return ls.Global_PracticeType_PilotagePractice;
    case PracticeType.InlandVessel:
      return ls.Global_PracticeType_InlandVesselPractice;
    case PracticeType.VtsCenter:
      return ls.Global_PracticeType_VtsCenterPractice;
    case PracticeType.ShipRepair:
      return ls.Global_PracticeType_ShipRepairPractice;
    default:
      return this.requirement.name;
  }
}

async choose(tableItem: TableItem) {
  new RequirementsClient().choosePractice(tableItem.id, this.application.id, this.requirement.id).then(
      () => this.$emit("application-changed"),
      error => this.$emit("error-happened", error, [`<a href="${this.$router.resolve({name: "seafarer-practices", params: {seafarerId: this.application.seafarerId}}).href}">${this.$ls.Applications_Requirements_Practices_Error_AddedPracticeIsInThisList}</a>`]));
}

async removeChosen(id: string) {
  new RequirementsClient().removeChosenPractice(id, this.application.id, this.requirement.id).then(
      () => this.$emit("application-changed"),
      error => this.$emit("error-happened", error));
}

fields() {
  let type = PracticeType.ShipRepair;
  if(this.choosablePractices && this.choosablePractices.length > 0){
    type = this.choosablePractices[0].type;
  }
  else if(this.chosenPractices && this.chosenPractices.length > 0){
    type = this.chosenPractices[0].type;
  }

    switch (type) {
        case PracticeType.ShipRepair:
            return [
                {
                    key: 'position', label: this.$ls.Documents_Practices_Label_Position, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => item.positionName?.toString() ?? ''
                },
                { key: 'organizationName', label: this.$ls.PersonProfile_Practices_Table_Label_PracticeOrganization, sortable: true },
                // {
                //     key: 'issuedOn', label: this.$ls.Global_Label_IssueDateShort, sortable: true,
                //     formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => formatDate(item.issuedOn)
                // },
                {
                    key: 'startedOn', label: this.$ls.PersonProfile_Practices_Table_Label_StartingDate, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => formatDate(item.startedOn)
                },
                {
                    key: 'endedOn', label: this.$ls.PersonProfile_Practices_Table_Label_EndingDate, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => formatDate(item.endedOn)
                },
                {
                    key: 'totalDays', label: this.$ls.Common_Label_Sum, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => {let sum = 0; item.practicePeriods.forEach(f => sum += f.durationInDays??0); return sum.toString() }
                },
                {
                    key: 'status', label: this.$ls.PersonProfile_Practices_Table_Label_Status, sortable: true, sortByFormatted: true, thClass: 'w-10'
                },
                { key: 'actions', label: '', sortable: false,  tdClass: 'table-actions' }
            ] as BvTableFieldArray;

        case PracticeType.Seafaring:
            return [
                {
                    key: 'position', label: this.$ls.Documents_Practices_Label_Position, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => item.positionName?.toString() ?? ''
                },
                { key: 'kind', label: this.$ls.Applications_Requirements_Practices_Table_Label_PracticeKind, sortable: true, thClass: "w-8", formatter:(value: unknown, key:number, item: PracticeRequirementCandidateModel): string => translatePracticeKind(item.kind) },
                { key: "shipName", label: this.$ls.Documents_Practices_Heading_Ship, formatter: (value: unknown, key: number, item: PracticeRequirementCandidateModel): string|undefined => item.seafaringDetails?.shipName },
                { key: "imo", label: this.$ls.Documents_Practices_Label_ShipImoNumber_Short, formatter: (value: unknown, key: number, item: PracticeRequirementCandidateModel): string|null|undefined => item.seafaringDetails?.imoNr },
                { key: "gt", label: this.$ls.Documents_Practices_Label_ShipGrossTonnage_Short, formatter: (value: unknown, key: number, item: PracticeRequirementCandidateModel): number|undefined => item.seafaringDetails?.shipGrossTonnage },
                { key: "kw", label:  this.$ls.Documents_Practices_Label_ShipMainPower_Short, formatter: (value: unknown, key: number, item: PracticeRequirementCandidateModel): number|undefined => item.seafaringDetails?.shipMainPower },
                //  {
                //     key: 'issuedOn', label: this.$ls.Global_Label_IssueDateShort, sortable: true,
                //     formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => formatDate(item.issuedOn)
                // },
                {
                    key: 'startedOn', label: this.$ls.PersonProfile_Practices_Table_Label_StartingDate, sortable: true, thClass: "w-8",
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => formatDate(item.startedOn)
                },
                {
                    key: 'endedOn', label: this.$ls.PersonProfile_Practices_Table_Label_EndingDate, sortable: true, thClass: "w-8",
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => formatDate(item.endedOn)
                },
                {
                    key: 'totalDays', label: this.$ls.Common_Label_Sum, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => { let sum = 0; item.practicePeriods.forEach(f => sum += f.durationInDays??0); return sum.toString() }
                },
                {
                    key: 'engine', label: this.$ls.Documents_Practices_Modal_AddPracticePeriod_Label_EngineRoomWatchDays_Short, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => { let sum = 0; item.practicePeriods.forEach(f => sum += f.engineRoomWatchDays??0); return sum.toString() }
                },
                {
                    key: 'navigation', label: this.$ls.Documents_Practices_Modal_AddPracticePeriod_Label_NavigationalWatchDays_Short, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => { let sum = 0; item.practicePeriods.forEach(f => sum += f.navigationalWatchDays??0); return sum.toString() }
                },
                {
                    key: 'status', label: this.$ls.PersonProfile_Practices_Table_Label_Status, sortable: true, sortByFormatted: true, tdClass: "table-status"
                },
                { key: 'actions', label: '', sortable: false, thClass: 'w-5', tdClass: 'table-actions' }
            ] as BvTableFieldArray;

          case PracticeType.Pilotage:
            return [
                {
                    key: 'pilotageType', label: this.$ls.Documents_Practices_Label_PilotageType_2, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => this.getPilotageTypeName(item.pilotageType)
                },
                { key: 'kind', label: this.$ls.Applications_Requirements_Practices_Table_Label_PracticeKind, sortable: true, thClass: "w-8", formatter:(value: unknown, key:number, item: PracticeRequirementCandidateModel): string => translatePracticeKind(item.kind) },
                { key: "shipName", label: this.$ls.Documents_Practices_Heading_Ship, formatter: (value: unknown, key: number, item: PracticeRequirementCandidateModel): string|undefined => item.seafaringDetails?.shipName },
                { key: "imo", label: this.$ls.Documents_Practices_Label_ShipImoNumber_Short, formatter: (value: unknown, key: number, item: PracticeRequirementCandidateModel): string|null|undefined => item.seafaringDetails?.imoNr },
                { key: "gt", label: this.$ls.Documents_Practices_Label_ShipGrossTonnage_Short, formatter: (value: unknown, key: number, item: PracticeRequirementCandidateModel): number|undefined => item.seafaringDetails?.shipGrossTonnage },
                { key: "kw", label:  this.$ls.Documents_Practices_Label_ShipMainPower_Short, formatter: (value: unknown, key: number, item: PracticeRequirementCandidateModel): number|undefined => item.seafaringDetails?.shipMainPower },
                {
                    key: 'startedOn', label: this.$ls.PersonProfile_Practices_Table_Label_StartingDate, sortable: true, thClass: "w-8",
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => formatDate(item.startedOn)
                },
                {
                    key: 'endedOn', label: this.$ls.PersonProfile_Practices_Table_Label_EndingDate, sortable: true, thClass: "w-8",
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => formatDate(item.endedOn)
                },
                {
                    key: 'totalDays', label: this.$ls.Common_Label_Sum, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => {
                        return item.practicePeriods.length.toString();
                    }
                },
                {
                    key: 'status', label: this.$ls.PersonProfile_Practices_Table_Label_Status, sortable: true, sortByFormatted: true, tdClass: "table-status"
                },
                { key: 'actions', label: '', sortable: false, thClass: 'w-5', tdClass: 'table-actions' }
            ] as BvTableFieldArray;

          case PracticeType.InlandVessel:
            return [
                {
                    key: 'position', label: this.$ls.Documents_Practices_Label_Position, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => item.positionName?.toString() ?? ''
                },
                { key: 'kind', label: this.$ls.Applications_Requirements_Practices_Table_Label_PracticeKind, sortable: true, thClass: "w-8", formatter:(value: unknown, key:number, item: PracticeRequirementCandidateModel): string => translatePracticeKind(item.kind) },
                { key: "shipName", label: this.$ls.Documents_Practices_Heading_Ship, formatter: (value: unknown, key: number, item: PracticeRequirementCandidateModel): string|undefined => item.seafaringDetails?.shipName },
                { key: "imo", label: this.$ls.Documents_Practices_Label_ShipImoNumber_Short, formatter: (value: unknown, key: number, item: PracticeRequirementCandidateModel): string|null|undefined => item.seafaringDetails?.imoNr },
                { key: "gt", label: this.$ls.Documents_Practices_Label_ShipGrossTonnage_Short, formatter: (value: unknown, key: number, item: PracticeRequirementCandidateModel): number|undefined => item.seafaringDetails?.shipGrossTonnage },
                { key: "kw", label:  this.$ls.Documents_Practices_Label_ShipMainPower_Short, formatter: (value: unknown, key: number, item: PracticeRequirementCandidateModel): number|undefined => item.seafaringDetails?.shipMainPower },
                {
                    key: 'startedOn', label: this.$ls.PersonProfile_Practices_Table_Label_StartingDate, sortable: true, thClass: "w-8",
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => formatDate(item.startedOn)
                },
                {
                    key: 'endedOn', label: this.$ls.PersonProfile_Practices_Table_Label_EndingDate, sortable: true, thClass: "w-8",
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => formatDate(item.endedOn)
                },
                {
                    key: 'totalDays', label: this.$ls.Common_Label_Sum, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => { let sum = 0; item.practicePeriods.forEach(f => sum += f.durationInDays??0); return sum.toString() }
                },
                {
                    key: 'status', label: this.$ls.PersonProfile_Practices_Table_Label_Status, sortable: true, sortByFormatted: true, tdClass: "table-status"
                },
                { key: 'actions', label: '', sortable: false, thClass: 'w-5', tdClass: 'table-actions' }
            ] as BvTableFieldArray;

          case PracticeType.VtsCenter:
            return [
                {
                    key: 'position', label: this.$ls.Documents_Practices_Label_Position, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => item.positionName?.toString() ?? ''
                },
                { key: 'organizationName', label: this.$ls.PersonProfile_Practices_Table_Label_PracticeOrganization, sortable: true },
                {
                    key: 'startedOn', label: this.$ls.PersonProfile_Practices_Table_Label_StartingDate, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => formatDate(item.startedOn)
                },
                {
                    key: 'endedOn', label: this.$ls.PersonProfile_Practices_Table_Label_EndingDate, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => formatDate(item.endedOn)
                },
                {
                    key: 'totalDays', label: this.$ls.Common_Label_Sum, sortable: true,
                    formatter: (value: unknown, key: string, item: PracticeRequirementCandidateModel): string => {let sum = 0; item.practicePeriods.forEach(f => sum += f.durationInDays??0); return sum.toString() }
                },
                {
                    key: 'status', label: this.$ls.PersonProfile_Practices_Table_Label_Status, sortable: true, sortByFormatted: true, thClass: 'w-10'
                },
                { key: 'actions', label: '', sortable: false,  tdClass: 'table-actions' }
            ] as BvTableFieldArray;
    }
}
get chosenPracticeTableItems() : TableItem[] {
  if (!this.chosenPractices)
    return [];
  return this.chosenPractices.map(x => new PracticeTableItem(x))
}

get choosablePracticesTableItems(): TableItem[] {
  //type casting as choosable do not provide correct type
  this.choosablePractices.forEach(item =>
    item.seafaringDetails = new SeafaringProperties(item.seafaringDetails as ISeafaringProperties)
  );
  return this.choosablePractices.map(x => new PracticeTableItem(x));
}

get isSeafaringPractice(): boolean {
  let type = PracticeType.ShipRepair;
  if(this.choosablePractices && this.choosablePractices.length > 0){
    type = this.choosablePractices[0].type;
  }
  else if(this.chosenPractices && this.chosenPractices.length > 0){
    type = this.chosenPractices[0].type;
  }
  return type === PracticeType.Seafaring;
}

viewDetails(practice: PracticeTableItem){
  const routeMap: { [id: string] : string; } = {};
  routeMap[PracticeType.Seafaring] = "requirement-seafaring-practice-details";
  routeMap[PracticeType.ShipRepair] = "requirement-ship-repair-practice-details";
  routeMap[PracticeType.Pilotage] = "requirement-pilotage-practice-details";
  routeMap[PracticeType.InlandVessel] = "requirement-inland-vessel-practice-details";
  routeMap[PracticeType.VtsCenter] = "requirement-vts-center-practice-details";
  this.$router.push({name: routeMap[practice.type], params:{id: practice.id, seafarerId: this.application.seafarerId, requirementId: this.requirement.id}})
}

 getPilotageTypeName(pilotage?:PilotageType|null): string {
  if (pilotage === PilotageType.Pilotage) {
    return this.$ls.Documents_Practices_PilotageType_Pilotage;
  } else if (pilotage === PilotageType.PracticalPilotage) {
    return this.$ls.Documents_Practices_PilotageType_PracticalPilotage;
  }
  return this.$ls.Documents_Practices_PilotageType_Undetermined;
}

hasChosenEducationalDays() {
  return this.suitableEducationalPeriodDays > 0 || this.suitableEducationalPeriodDays > 0 || this.educationalPeriodPracticeDays > 0;
}

hasChosenWorkDays() {
  return this.suitableWorkPeriodDays > 0 || this.suitableWorkPeriodDays > 0 || this.workPracticePeriodDays > 0;
}

isCountBased(): boolean {
  return this.requirement.isCountBased;
}

addNewPractice(){
  this.$refs.addPracticeModal.open(this.application.seafarerId);
}
}
